import ProjectFilters from './modules/project-filters';

// vars
let filters;


// auto initialization
init();


function init() {
  if (PROJECT_TYPE === 'art') {
    filters = new ProjectFilters();
    filters.init();
    filters.apply();
  }
}
